const summaries = document.querySelectorAll("summary.facets__summary");
console.log("element array ", summaries);
const checkingURL = window.location.href;

if (checkingURL.includes(".ae")) {
  summaries.forEach((summary) => {
    if (summary.ariaLabel !== null) {
      const details = summary.parentNode;
      if (
        summary.ariaLabel.includes("(INR)") ||
        summary.ariaLabel.includes("(SGD)") ||
        summary.ariaLabel.includes("(ft)") ||
        summary.ariaLabel.includes("(inr)") ||
        summary.ariaLabel.includes("(sgd)") 
      ) {
        console.log("parent element", details);
        details.style.display = "none";
      } else if (summary.ariaLabel.includes("(AED)")) {
        const priceList = details.querySelectorAll(".list-menu__item");
        console.log("AE list is ", priceList);
        priceList.forEach(function (item) {
          let spanElement = item.querySelector('span[aria-hidden="true"]');
          if (spanElement) {
              spanElement.textContent += "AED";
          }
        });
      }
    }
  });
} else if (checkingURL.includes(".asia")) {
  summaries.forEach((summary) => {
    if (summary.ariaLabel !== null) {
      const details = summary.parentNode;
      if (
        summary.ariaLabel.includes("(AED)") ||
        summary.ariaLabel.includes("(INR)") ||
        summary.ariaLabel.includes("(ft)") ||
        summary.ariaLabel.includes("(aed)") ||
        summary.ariaLabel.includes("(inr)") 
      ) {
        console.log("parent element", details);
        details.style.display = "none";
      } else if (summary.ariaLabel.includes("(SGD)")) {
        const priceList = details.querySelectorAll(".list-menu__item");
        console.log("SG list is ", priceList);
        priceList.forEach(function (item) {
          let spanElement = item.querySelector('span[aria-hidden="true"]');
          if (spanElement) {
              spanElement.textContent += "SGD";
          }
        });
      }
    }
  });
} else if (checkingURL.includes(".com")) {
  summaries.forEach((summary) => {
    if (summary.ariaLabel !== null) {
      const details = summary.parentNode;
      if (
        summary.ariaLabel.includes("(AED)") ||
        summary.ariaLabel.includes("(SGD)") ||
        summary.ariaLabel.includes("(cm)") ||
         summary.ariaLabel.includes("(aed)") ||
        summary.ariaLabel.includes("(sgd)") 
      ) {
        console.log("parent element", details);
        details.style.display = "none";
      } else if (summary.ariaLabel.includes("(INR)")) {
        const priceList = details.querySelectorAll(".list-menu__item");
        console.log("IN list is ", priceList);
        priceList.forEach(function (item) {
          let spanElement = item.querySelector('span[aria-hidden="true"]');
          if (spanElement) {
              spanElement.textContent += "INR";
          }
        });
      }
    }
  });
}
